module.exports = "https://assets.localphysio.net.au/_next/static/images/2938171-d26a3d9dad4f4e51085197e6b6919a6e.jpg";